export default __webpack_public_path__ + "static/media/icon_travelport-certified.d5d1f0f1.svg";